export default __webpack_public_path__ + "static/media/logo.3c4a0a38.png";